import { Button, Form } from "@fluentui/react-northstar";
import React from "react";
import uf from "usefuljs";
import axios from "axios";
import styles from "./tag.module.scss";

type TagProp = {
    image:string
}

enum Status {
    LoggedIn,
    LoggedOut,
    Verification
}


interface StatusTag {
    base64_image:string,
    status: Status,
}

const Tag = (props:TagProp)=>{
    const [tagStatus,setTagStatus] = React.useState("");

    const onTagImage = async(tag:Status):Promise<void>=>{
        try{
            setTagStatus("Tagging ...");
            const body:StatusTag = {
                base64_image: props.image,
                status: tag,
            };
            await axios.post("https://jennysss.lenx.ai/fbm/api/status/tag",body).catch(err=>{throw err});
            setTagStatus("Successfully tagged image");
        }catch(err){
            setTagStatus("Failed to tag image");
        }finally{
            await uf.sleep(3000);
            setTagStatus("");
        }
    }

    const onTagLoggedIn = async ():Promise<void> =>{
        await onTagImage(Status.LoggedIn);
    }

    const onTagLoggedOut = async ():Promise<void> =>{
        await onTagImage(Status.LoggedOut);
    }

    const onTagVerfication = async ():Promise<void> =>{
        await onTagImage(Status.Verification);
    }

    return (
        <div id={styles.tag}>
            <h4>Tag Status</h4>
            {
                tagStatus ? <p>{tagStatus}</p> :
                <Form 
                fields={
                    [
                        {
                            key: "Logged_In",
                            control: {
                                as: Button,
                                content: "Logged In",
                                onClick: onTagLoggedIn,
                            }
                        },
                        {
                            key: "Logged_Out",
                            control: {
                                as: Button,
                                content: "Logged Out",
                                onClick: onTagLoggedOut,
                            }
                        },
                        {
                            key: "Verification",
                            control: {
                                as: Button,
                                content: "Verification",
                                onClick: onTagVerfication,
                            }
                        }
                    ]
                }
            />
            }
            
        </div>
    )
}

export default Tag;